import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class CustomerIntegrationModel extends ResultsServiceModel {
  modelName () {
    return 'customer-integrations'
  }

  defaults () {
    return {
      id: null,
      customer_id: null,
      integration_id: null,
      config: null,
      status: null,
      status_note: null,
      last_runtime_at: null,
      last_complete_at: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      customer_id: val => this.nullStringMutator(val),
      integration_id: val => this.nullStringMutator(val),
      status: val => this.nullStringMutator(val),
      status_note: val => this.nullStringMutator(val),
      last_runtime_at: val => (val ? this.nullStringMutator(val) : undefined),
      last_complete_at: val => (val ? this.nullStringMutator(val) : undefined),
      created_at: val => (val ? this.nullStringMutator(val) : undefined),
      updated_at: val => (val ? this.nullStringMutator(val) : undefined),
      deleted_at: val => (val ? this.nullStringMutator(val) : undefined),
    };
  }
}
